import store from '@/store/store';
import { Vue, Options } from 'vue-class-component';

@Options({
	name: 'TooltipComponent',
	props: {
		innerData: { type: String, required: true },
		size: { type: String, default: 'default' }, // default | large
		type: { type: String, default: 'text' }, // text | icon (for vertical alignment)
		buttonClass: { type: String, default: '' },
	},
})
export default class TooltipComponent extends Vue {
	innerData: string;
	size: string; // default | large
	type: string; // text | icon (for vertical alignment)
	buttonClass: string;

	public toggle(e) {
		store.state.modal = this.createModal();
	}

	private createModal() {
		const modal: any = {};
		modal.show = true;
		modal.id = 'popover';
		modal.track = false;
		modal.trackToken = undefined;
		modal.content = this.innerData;
		modal.btnStyle = 'Button Button__secondary';
		modal.btnLabel = undefined;
		modal.btnIcon = undefined;
		modal.btnSecondStyle = undefined;
		modal.btnSecondLabel = undefined;
		modal.btnInlineLabel = undefined;
		modal.btnInlineAction = undefined;
		modal.btnInlinestyle = undefined;
		modal.title = undefined;
		modal.redirect = undefined;
		return modal;
	}
}
